import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=809dac3a&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809dac3a",
  null
  
)

export default component.exports